import { RootState } from 'store';

export const configDataSelector = (state: RootState) => state.config.data;

export const configIsLoadingSelector = (state: RootState) =>
  state.config.isLoading;

export const configErrorSelector = (state: RootState) => state.config.error;
